import React from 'react';
import ArticleCard from './ArticleCard';
import './ArticleList.css';

function ArticleList({ articles, onDeleteArticle }) {
  if (articles.length === 0) {
    return (
      <div className="empty-state">
        <div className="empty-icon">📄</div>
        <h3>No articles yet</h3>
        <p>Start by creating your first article!</p>
      </div>
    );
  }

  return (
    <div className="article-list">
      {articles.map(article => (

        <ArticleCard
          key={article.id}
          article={article}
          onDelete={onDeleteArticle}
        />
        
      ))}
    </div>
  );
}

export default ArticleList;
